import { render, staticRenderFns } from "./planningAdd.vue?vue&type=template&id=3f65e720&scoped=true"
import script from "./planningAdd.vue?vue&type=script&lang=js"
export * from "./planningAdd.vue?vue&type=script&lang=js"
import style0 from "./planningAdd.vue?vue&type=style&index=0&id=3f65e720&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f65e720",
  null
  
)

export default component.exports